import {connect} from 'react-redux';
import Solds from '../components/solds/solds';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    config: state.store.config
  };
};

export default connect(mapStateToProps)(Solds);



// WEBPACK FOOTER //
// ./src/containers/solds.js